module.exports = __webpack_public_path__ + "img/1975.4a95b4ad.png";